var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24236 4.5H2.49264L2.49263 3.32223C2.49263 1.27778 4.24223 2.29333e-06 5.74189 0C7.24155 -7.59041e-06 8.99114 1.27779 8.99114 2.81112H8.49126C8.49126 1.7889 7.24154 0.511108 5.74189 0.511111C4.24223 0.511114 2.99252 1.78889 2.99252 3.32223V4.5H10.2403C10.2403 4.5 10.4902 4.51667 10.4902 4.75C10.4902 4.98334 10.4834 10.4778 10.4834 10.4778C10.4834 11.0426 9.9529 11.5 9.29799 11.5H2.18579C1.53087 11.5 1.00042 11.0426 1.00042 10.4778V4.75C0.992414 4.5 1.24236 4.5 1.24236 4.5ZM2.18579 10.9889H9.29799C9.69492 10.9861 9.99035 10.5 9.99035 10.25V4.98333H1.49286V10.2222C1.45749 10.636 1.78163 10.9749 2.18579 10.9889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74189 9.45556C6.57012 9.45556 7.24154 8.76906 7.24154 7.92222C7.24154 7.07539 6.57012 6.38889 5.74189 6.38889C4.91365 6.38889 4.24223 7.07539 4.24223 7.92222C4.24223 8.76906 4.91365 9.45556 5.74189 9.45556ZM5.74189 8.94444C6.29404 8.94444 6.74166 8.48678 6.74166 7.92222C6.74166 7.35766 6.29404 6.9 5.74189 6.9C5.18973 6.9 4.74212 7.35766 4.74212 7.92222C4.74212 8.48678 5.18973 8.94444 5.74189 8.94444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/Unlock.395fef20dcc31a127cad18b1c50844dc.svg";
export { ForwardRef as ReactComponent };